// extracted by css-extract-rspack-plugin
module.exports =  {"root":"d319ebbf83","titleLink":"f33bf9deb4","centered":"d9be7a39ec","title":"be855943d7"};